module.exports = __webpack_public_path__ + "static/icon-payment-maestro-bd7242bce6557f05b950a10b5c7196b8.svg";